/**
 * Tier pricing - updates tier block when variant changes.
 * Listens for on:variant:change from variant-picker.
 *
 * Shows/hides the tier block when the variant price exceeds the highest
 * tier threshold (product already qualifies for max discount).
 * Updates qty labels and discounted prices in the tier table.
 */
document.addEventListener('DOMContentLoaded', function () {
  const block = document.getElementById('tier-pricing-block');
  if (!block) return;

  const blockWrapper = block.closest('.product-info__block');
  const maxTierOver = parseInt(block.dataset.maxTierOver, 10) || 0;
  const symbol = block.dataset.currencySymbol || '£';

  function format(pence) {
    return symbol + (pence / 100).toFixed(2);
  }

  function updateTierPricing(pricePence) {
    if (isNaN(pricePence) || pricePence <= 0) return;

    const priceOverMaxTier = maxTierOver > 0 && pricePence > maxTierOver;
    if (blockWrapper) blockWrapper.hidden = priceOverMaxTier;

    for (let i = 1; i <= 3; i++) {
      const discount = parseFloat(block.getAttribute('data-tier-' + i + '-discount'));
      const over = parseFloat(block.getAttribute('data-tier-' + i + '-over'));
      if (!over || isNaN(discount)) continue;

      const overPence = over * 100;
      const qty = Math.ceil(overPence / pricePence);
      const discountedExPence = Math.round(pricePence * (100 - discount) / 100);
      const discountedIncPence = Math.round(discountedExPence * 1.2);

      const labels = block.querySelectorAll('.tier-pricing__row--labels .tier-pricing__cell');
      const prices = block.querySelectorAll('.tier-pricing__row--prices .tier-pricing__cell');
      if (labels[i - 1]) {
        const qtyEl = labels[i - 1].querySelector('.tier-pricing__qty');
        if (qtyEl) qtyEl.textContent = 'Buy ' + qty + '+';
      }
      if (prices[i - 1]) {
        const exEl = prices[i - 1].querySelector('.price__default .tier-pricing__price');
        const incEl = prices[i - 1].querySelector('.product__vat-price .tier-pricing__price');
        if (exEl) exEl.textContent = format(discountedExPence);
        if (incEl) incEl.textContent = format(discountedIncPence);
      }
    }
  }

  document.querySelector('.js-product')?.addEventListener('on:variant:change', function (e) {
    if (e.detail?.variant?.price) {
      updateTierPricing(e.detail.variant.price);
    }
  });

  const initialPrice = parseInt(block.dataset.currentPrice, 10);
  if (initialPrice > 0) {
    updateTierPricing(initialPrice);
  }
});
